module.exports = __webpack_public_path__ + "img/Cape_fr.e620e960.jpg";